module.exports = __webpack_public_path__ + "static/logo-giesla-ba10dd6a4fabb93b9c289e7e73242e5b.png";